
import { IColumn } from '../../../../../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';
import EDChip from '../../../../../../../../../../BaseComponents/Chip/EDChip';
import EDAvatar from '../../../../../../../../../../BaseComponents/Avatar/EDAvatar';
import EDTooltip from '../../../../../../../../../../BaseComponents/Tooltip/EDTooltip';
import EDIcon from '../../../../../../../../../../BaseComponents/Icon/EDIcon';
import { TECKENVAND_KOLUMN } from '../../../../../Const/EkonomiskAnalysConsts';
import EDBox from '../../../../../../../../../../BaseComponents/EDBox/EDBox';

interface IProps {
  column: IColumn;
}

/**
 * Chip för kolumninformation om radbaserade analyser
 */
const EkonomiskAnalysRadbaseradColumnChip: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const vandTecken = props.column.data.VAND_TECKEN;

  return (
    <EDBox sx={{ margin: '16px 0px' }} key={props.column.id}>
      <EDChip
        fullWidth
        avatar={
          <EDAvatar>
            <EDTooltip title={vandTecken ? TECKENVAND_KOLUMN : ''}>
              <EDBox sx={{ height: 24, width: 24 }}>
                {vandTecken && <EDIcon iconType={'reverse'} />}
              </EDBox>
            </EDTooltip>
          </EDAvatar>
        }
        label={
          <EDBox sx={{ display: 'flex', alignItems: 'center' }}>
            <EDTooltip title={props.column.displayLabel || props.column.name}>
              <EDBox
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  lineHeight: 'initial',
                  width: '100%',
                  textAlign: 'right',
                }}
              >
                {props.column.displayLabel || props.column.name}
              </EDBox>
            </EDTooltip>
          </EDBox>
        }
      />
    </EDBox>
  );
};

export default EkonomiskAnalysRadbaseradColumnChip;
